// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"544":"c3349382ffe4a044","798":"6614f55de8dc5196","810":"1d5188643e2f3c15","866":"87508df94cbe026e"}[chunkId] + ".js";
};